<template lang="pug">
  article
    breadcrumb-nav(:isLibrary="true")
    articles-feed.pt-120(:title="category && category.name", :articles="articles")
</template>

<script>
import BreadcrumbNav from '@/components/BreadcrumbNav'
import ArticlesFeed from '@/components/ArticlesFeed'
export default {
  name: 'Category',
  props: ['cat'],
  data () {
    return {
      articles: [],
      page: 1,
      total: 2
    }
  },
  computed: {
    category () {
      return this.$store.state.categories.find(cat => cat.slug === this.cat)
    }
  },
  methods: {
    getArticles () {
      if (this.page >= this.total) return console.log('end of feed')
      return this.$store.dispatch('getArticlesInCategory', { cat: this.cat, pg: this.page })
        .then(resp => {
          this.articles.push(...resp.posts)
          this.total = resp.totalPages
          this.page++
        })
    }
  },
  created () {
    this.getArticles()
  },
  components: { ArticlesFeed, BreadcrumbNav },
  metaInfo () {
    if (!this.category) return
    const title = `Library: ${this.category.name}`
    return {
      title: title,
      meta: this.$store.getters.meta({ title: title })
    }
  }
}
</script>

<style>
</style>
